import React, { Component, Context } from "react";
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import DeleteIcon2 from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/EditOutlined";
import PreviewIcon from "@material-ui/icons/VisibilityOutlined";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import { ICellRendererParams } from "ag-grid-community";
// import { AddEditEntityModal } from "../../../../addEditEntity";
// import { getEntityDisplay } from "../../../../../models/entity";
import { UIStyledTooltip } from "../../ui/UIComponents";
import UIConfirmDialog from "../../ui/UIConfirmDialog";
import { CustomAction, IActionable } from "../../../models/actions";

export class ActionsCellRenderer extends Component<
	ICellRendererParams & { component; customActions?: CustomAction[] }
> {
	private readonly entityName: string = "dana TODO";

	state = {
		confirmDeleteOpen: false,
		deleting: false,
		downloading: false,
		previewLoading: false,
		previewOpen: false,
		editEntityOpen: false,
	};

	render() {
		const component: IActionable<any> = this.props.component;
		const suffix: string = component.getActionSuffix
			? component.getActionSuffix(this.props.data, this.props)
			: ` ${this.entityName}`;
		const editText: string = component.getEditText ? component.getEditText(this.props.data, this.props) : "Edit";
		const downloadTitle: string = component.getDownloadTitle
			? component.getDownloadTitle(this.props.data)
			: `Download${suffix}`;
		const data = this.props.data;
		const deleteTitle = component.getConfirmDeleteTitle
			? component.getConfirmDeleteTitle(data)
			: component.entity
			? `Delete ${this.entityName}`
			: "Confirm Delete";
		const includeDelete: boolean = !!component.onDelete && (!component.hideDelete || !component.hideDelete(data));
		const disableDelete: boolean = component.disableDelete && component.disableDelete(data);
		const tooltip: string = disableDelete
			? component.getDisabledTitle
				? component.getDisabledTitle(data)
				: `Can't delete${suffix}`
			: `Delete${suffix}`;

		return (
			<div className="actions-toolbar-cell d-flex flex-row-reverse">
				{includeDelete && (
					<>
						<UIStyledTooltip title={tooltip}>
							<span className={clsx(disableDelete && "action-disabled")}>
								<IconButton
									edge="start"
									aria-label={`Delete${suffix}`}
									size="small"
									className="action-btn-icon delete-action-btn"
									disabled={this.state.deleting || disableDelete}
									onClick={(e) => {
										e.preventDefault();
										this.setState({ confirmDeleteOpen: true });
									}}
								>
									<DeleteIcon fontSize="small" />
									{this.state.deleting && (
										<CircularProgress className="position-absolute" size={16} />
									)}
								</IconButton>
							</span>
						</UIStyledTooltip>
						<UIConfirmDialog
							pageTitle={
								component.getConfirmDeletePageTitle
									? component.getConfirmDeletePageTitle(data)
									: component.entity
									? `Delete ${this.entityName}`
									: "Confirm Delete"
							}
							title={
								<div className="d-inline-flex align-items-start delete-warning-message mb-2">
									<WarningIcon className="text-warning mr-2" fontSize="small" />
									<span>{deleteTitle}</span>
								</div>
							}
							getDescription={() =>
								component.getConfirmDeleteDesc ? component.getConfirmDeleteDesc(data) : undefined
							}
							confirmBtnTxt={
								<span className="d-inline-flex align-items-center">
									<DeleteIcon2 style={{ fontSize: "15px" }} className="mr-1" /> Delete
								</span>
							}
							open={this.state.confirmDeleteOpen}
							onCancel={() => this.setState({ confirmDeleteOpen: false })}
							onConfirm={() => {
								this.setState({ deleting: true });
								return component.onDelete(data).finally(() => {
									this.setState({ confirmDeleteOpen: false, deleting: false });
								});
							}}
						/>
					</>
				)}
				{component.getUploadBtn && !(component.hideUpload && component.hideUpload(data))
					? component.getUploadBtn(data)
					: null}
				{component.onDownload && !(component.hideDownload && component.hideDownload(data)) && (
					<UIStyledTooltip title={downloadTitle}>
						<IconButton
							edge="start"
							aria-label={downloadTitle}
							size="small"
							className="action-btn-icon download-action-btn"
							disabled={this.state.downloading}
							onClick={(e) => {
								e.preventDefault();
								this.setState({ downloading: true });
								component.onDownload(data).finally(() => {
									this.setState({ downloading: false });
								});
							}}
						>
							<DownloadIcon fontSize="small" />
							{this.state.downloading && <CircularProgress className="position-absolute" size={16} />}
						</IconButton>
					</UIStyledTooltip>
				)}
				{component.onPreview && (
					<>
						<UIStyledTooltip title={`Preview${suffix}`}>
							<IconButton
								edge="start"
								aria-label={`Preview${suffix}`}
								size="small"
								className="action-btn-icon"
								disabled={this.state.previewLoading}
								// onClick={() => {
								// 	this.setState({ previewLoading: true });
								// 	component.onPreview(data, this.props).finally(() => {
								// 		this.setState({ previewLoading: false });
								// 	});
								// }}
							>
								<PreviewIcon fontSize="small" />
								{this.state.previewLoading && (
									<CircularProgress className="position-absolute" size={16} />
								)}
							</IconButton>
						</UIStyledTooltip>
					</>
				)}
				{component.withEditEntityForm && (!component.hideEdit || !component.hideEdit(data)) && (
					<>
						<UIStyledTooltip title={`Edit ${suffix}`}>
							<IconButton
								edge="start"
								aria-label={`Edit ${suffix}`}
								size="small"
								className="action-btn-icon corre-actions-edit-action"
								onClick={(e) => {
									e.preventDefault();
									this.setState({ editEntityOpen: true });
								}}
							>
								<i
									className="im im-edit"
									style={{
										fontSize: "1.01rem",
										paddingRight: 2,
										paddingLeft: 2,
									}}
								></i>
							</IconButton>
						</UIStyledTooltip>
						{/* <AddEditEntityModal
							mode="Edit"
							entity={component.entity}
							data={data}
							colDefs={component.colDefs}
							omitUserConfigurations={component.omitUserConfigurations}
							gridKey={component.gridKey}
							dataView={component.dataView}
							getDataView={component.getDataView ? component.getDataView.bind(component) : null}
							onUpdateEntity={(data, originalData?) => component.onUpdateEntity(data, originalData)}
							open={this.state.editEntityOpen}
							onCancel={() => this.setState({ editEntityOpen: false })}
						/> */}
					</>
				)}
				{component.onEdit && (!component.hideEdit || !component.hideEdit(data)) && (
					<UIStyledTooltip
						title={`${editText} In-place ${suffix}`}
						className="corre-actions-edit-grid-action"
					>
						<IconButton
							edge="start"
							aria-label={`${editText}${suffix}`}
							size="small"
							className="action-btn-icon"
							onClick={(e) => {
								e.preventDefault();
								const onEditFn = component.onEdit.bind(component);
								onEditFn(data, this.props);
							}}
						>
							<EditIcon fontSize="small" />
						</IconButton>
					</UIStyledTooltip>
				)}
				{(this.props.customActions || []).map((action: CustomAction, i) => {
					const disabled: boolean = action.disabled && action.disabled(data);
					const title: string =
						disabled && action.disabledTitle
							? action.disabledTitle(data)
							: action.getTitle
							? action.getTitle(data)
							: action.title;
					const dynamicStateProp: string = `action_${i}`;
					return (
						(action.predicate ? action.predicate(data) : true) && (
							<UIStyledTooltip title={title} key={i}>
								<span className={clsx(disabled && "action-disabled")}>
									<IconButton
										edge="start"
										aria-label={title}
										size="small"
										className="action-btn-icon"
										disabled={this.state[dynamicStateProp] || disabled}
										onClick={(e) => {
											e.preventDefault();
											this.setState((prevState) => ({
												...prevState,
												[dynamicStateProp]: true,
											}));
											action.callback(data).finally(() => {
												this.setState((prevState) => ({
													...prevState,
													[dynamicStateProp]: false,
												}));
											});
										}}
									>
										<action.icon fontSize="small" />
										{this.state[dynamicStateProp] && (
											<CircularProgress className="position-absolute" size={16} />
										)}
									</IconButton>
								</span>
							</UIStyledTooltip>
						)
					);
				})}
			</div>
		);
	}
}
